import React, { useState } from "react";
import { Trash2, Plus } from "lucide-react";

const D = {
  blue: "#3b82f6",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

const EditableFilter = (props) => {
    const {
    infoSource,
    filter,
    clickSubmitEdit
    } = props
const {
    getButtonTitle
    } = infoSource

    const [data, setData] = useState(filter)

  // Handle name change
  const handleNameChange = (e) => {
    setData({ ...data, name: e.target.value });
  };

  // Handle filter item change
  const handleFilterChange = (index, newValue) => {
    const updatedFilters = [...data.FilterItem];
    updatedFilters[index] = newValue;
    setData({ ...data, FilterItem: updatedFilters });
  };

  // Add a new filter item
  const addFilterItem = () => {
    setData({ ...data, FilterItem: [...data.FilterItem, ""] });
  };

  // Remove a filter item
  const removeFilterItem = (index) => {
    const updatedFilters = data.FilterItem.filter((_, i) => i !== index);
    setData({ ...data, FilterItem: updatedFilters });
  };

  const inputStyle = { width: "100%", padding: "8px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", fontFamily: D.font, boxSizing: "border-box" };

  return (
    <div style={{ fontFamily: D.font }}>
      <label style={{ display: "block", marginBottom: 16 }}>
        <span style={{ display: "block", fontSize: 11, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: .6, marginBottom: 6 }}>
          {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editFilterElakay.t001}
        </span>
        <input
          style={inputStyle}
          type="text"
          value={data.name}
          onChange={handleNameChange}
        />
      </label>

      <h4 style={{ fontSize: 12, fontWeight: 700, color: D.txt2, textTransform: "uppercase", letterSpacing: .5, marginBottom: 10 }}>
        {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editFilterElakay.t002}
      </h4>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 14 }}>
        {data.FilterItem?.map((item, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input
              style={{ ...inputStyle, flex: 1 }}
              type="text"
              value={item}
              onChange={(e) => handleFilterChange(index, e.target.value)}
            />
            <button
              type="button"
              onClick={() => removeFilterItem(index)}
              title={getButtonTitle("deleteFilter")}
              style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer", flexShrink: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = "#fee2e2"; e.currentTarget.style.color = "#ef4444"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
            >
              <Trash2 size={15} />
            </button>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button
          type="button"
          onClick={addFilterItem}
          title={getButtonTitle("addNew")}
          style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 8, border: `1px solid ${D.border}`, background: "#fff", color: D.txt2, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
        >
          <Plus size={14} />
          {getButtonTitle("addNew")}
        </button>
        <button
          type="button"
          onClick={()=>clickSubmitEdit(filter.filter_id, data)}
          style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
        >
          {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editFilterElakay.t003}
        </button>
      </div>
    </div>
  );
};

export default EditableFilter;
